import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';

type OpeType =
  | 'liv_titre'
  | 'ventre_titre'
  | 'restitu_pension_titre'
  | 'mise_pension_titre'
  | 'defaut_pension_titre'
  | 'remb_titre'
  | 'non_remb_titre'
  | 'pret_titre'
  | 'restitu_pret_titre'
  | 'defaut_pret_titre'
  | 'transf_titre_CRCT'
  | 'transf_titre_SVT'
  | 'litige_titre'
  | 'fin_litige_titre';

export const getSchema = (
  user: ConnectedUserEntity,
  detenteur: DetenteurEntity,
  codeOPeraton: OpeType,
) => {
  let schema = '';
  let comptePropre = user.partenaire.code_referent === detenteur.code_referent;

  if (codeOPeraton === 'liv_titre') {
    // notification de livraison de titre
    if (comptePropre) {
      schema = 'ETNLCP'; // compte propre
    } else {
      schema = 'ETNLCT'; // compte tier
    }
  } else if (codeOPeraton === 'ventre_titre') {
    // vente du titre
    if (comptePropre) {
      schema = 'VENTCP'; // compte propre
    } else {
      schema = 'VENTCT'; // compte tier
    }
  } else if (codeOPeraton === 'mise_pension_titre') {
    // Mise en pension
    if (comptePropre) {
      schema = 'MISPENCP'; // compte propre
    } else {
      schema = 'MISPENCT'; // compte tier
    }
  } else if (codeOPeraton === 'restitu_pension_titre') {
    // Restitution en pension livrée
    if (comptePropre) {
      schema = 'RPLIVCP'; // livrée compte propre
    } else {
      schema = 'RPLIVCT'; // livrée compte tier
    }
  } else if (codeOPeraton === 'defaut_pension_titre') {
    // Mise en pension
    if (comptePropre) {
      schema = 'DRPLIVCP'; // livrée compte propre
    } else {
      schema = 'DRPLIVCT'; // livrée compte tier
    }
  } else if (codeOPeraton === 'remb_titre') {
    // Remboursement de titre
    if (comptePropre) {
      schema = 'REMBCP'; // compte propre
    } else {
      schema = 'REMBCT'; // compte tier
    }
  } else if (codeOPeraton === 'non_remb_titre') {
    // Non remboursement de titre
    if (comptePropre) {
      schema = 'NREMBCP'; // compte propre
    } else {
      schema = 'NREMBCT'; // compte tier
    }
  } else if (codeOPeraton === 'pret_titre') {
    // Prêt de titre
    if (comptePropre) {
      schema = 'PRETCP'; // compte propre
    } else {
      schema = 'PRETCT'; // compte tier
    }
  } else if (codeOPeraton === 'restitu_pret_titre') {
    // Restitution du Prêt de titre
    if (comptePropre) {
      schema = 'RPRETCP'; // compte propre
    } else {
      schema = 'RPRETCT'; // compte tier
    }
  } else if (codeOPeraton === 'defaut_pret_titre') {
    // Défaut de restitution d'un Prêt de titre
    if (comptePropre) {
      schema = 'DRPRETCP'; // compte propre
    } else {
      schema = 'DRPRETCT'; // compte tier
    }
  } else if (codeOPeraton === 'transf_titre_CRCT') {
    // Transfert de titres reçus à la CRCT
    if (comptePropre) {
      schema = 'TRFCRCTCP'; // compte propre
    } else {
      schema = 'TRFCRCTCT'; // compte tier
    }
  } else if (codeOPeraton === 'transf_titre_SVT') {
    // Transfert par la CRCT vers autre SVT
    if (comptePropre) {
      schema = 'TRFSVTCP'; // compte propre
    } else {
      schema = 'TRFSVTCT'; // compte tier
    }
  } else if (codeOPeraton === 'litige_titre') {
    // Litige
    if (comptePropre) {
      schema = 'LITCP'; // compte propre
    } else {
      schema = 'LITCT'; // compte tier
    }
  } else if (codeOPeraton === 'fin_litige_titre') {
    // Fin du litige
    if (comptePropre) {
      schema = 'FLITCP'; // compte propre
    } else {
      schema = 'FLITCT'; // compte tier
    }
  }

  return schema;
};
